import * as FullStory from '@fullstory/browser';
import { shouldIntegrateSentry } from '@modules/sentry';
import { BrowserTracing } from '@sentry/browser';
import SentryFullStory from '@sentry/fullstory';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';

export const initializeSentry = () => {
  if (!shouldIntegrateSentry()) {
    return;
  }

  Sentry.init({
    dsn: 'https://d51bad3b9d5346219e1e5498aac57101@o524486.ingest.sentry.io/5636992',
    integrations: [
      new BrowserTracing(),
      new SentryFullStory('enterpret', {
        client: FullStory,
      }),
      new posthog.SentryIntegration(
        posthog,
        'enterpret',
        5636992,
        'https://enterpret.sentry.io/organizations/',
        ['error'],
      ),
    ],
    ignoreErrors: [
      // Ignore network errors caused by connection outage
      /NetworkError when attempting to fetch resource/,
      //Ignore error caused by token expiration
      /Received status code 401/,
      // Ignore RecordNotFound (404) errors
      /record not found/,

      /no record found/,

      /Code: ErrCodeRecordNotFound, Msg: unauthorized - Code: ErrCodeRecordNotFound, Msg: Code: ErrCodeUnauthorized, Msg: no user found for the email/,

      /generateFeedbackSummary operation failed: cannot send data to user on this session/,

      /getAssistantResponse operation failed: Code: ErrCodeUnprocessableEntity, Msg: cannot send data to user on this session/,

      /signal is aborted without reason/,
    ],
    environment: process.env.REACT_APP_ENVIRONMENT,
    // ##TODO, fix this
    // release: process.env.COMMIT_ID,

    // We recommend adjusting this value in production, or using
    // tracesSampler for finer control
    tracesSampleRate: 1.0,
  });
};
